import { pathOr } from 'ramda';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { IPinsLayer } from './usePinsLayer';
import { setOffersCount } from '../../../../common/actions/offersCount';
import { selectResultsStatus } from '../../../../common/selectors/results';
import { IFeaturesMap, IRBushItem } from '../../../../common/types/map';
import { IApplicationState, TThunkDispatch } from '../../../../common/types/redux';
import { EResultsStatus } from '../../../../common/types/results';
import { selectMapBounds } from '../../../selectors';
import { TMapBounds } from '../../../types/mapBounds';

const DEFAULT_FEATURES_VALUE = {};

export function usePinsOffersCounter({ rbush }: IPinsLayer): void {
  const dispatch = useDispatch<TThunkDispatch>();
  const { bounds, precision } = useSelector<IApplicationState, TMapBounds>(selectMapBounds);
  const resultsStatus = useSelector<IApplicationState, EResultsStatus>(selectResultsStatus);
  const features = useSelector<IApplicationState, IFeaturesMap>(state =>
    pathOr<IFeaturesMap>(DEFAULT_FEATURES_VALUE, [precision, 'features'], state.map.features),
  );

  React.useEffect(() => {
    if (!bounds || resultsStatus === EResultsStatus.Loading) {
      return;
    }

    const featuresInBbox = rbush.search({
      minX: bounds[0][0],
      minY: bounds[0][1],
      maxX: bounds[1][0],
      maxY: bounds[1][1],
    });

    const totalCount: number = featuresInBbox.reduce((acc: number, rbushItem: IRBushItem) => {
      // eslint-disable-next-line no-param-reassign
      acc += rbushItem.feature.properties.offers.length;

      return acc;
    }, 0);

    dispatch(setOffersCount(totalCount));
  }, [bounds, dispatch, rbush, resultsStatus, features, precision]);
}
